import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'nf-t-day',
  templateUrl: './t-day.component.html',
  styleUrls: ['./t-day.component.css']
})
export class TDayComponent implements OnInit {
  TDayConfig = {
    type: 'daily',
    offset: {
      count: 1,
      unit: 'days'
    },
    description: null
  };
  offset = 1;
  count = 1;
  dateTypes = [
    {
      value: 'workdays',
      title: '工作日'
    },
    {
      value: 'days',
      title: '自然日'
    }
  ];
  orderTypes = [
    {
      value: 1,
      title: '正数'
    },
    {
      value: -1,
      title: '倒数'
    }
  ];
  @Input('nfData') set ChangeData(data: any) {
    if (data) {
      this.TDayConfig = data;
      if (this.TDayConfig.offset) {
        const offset = this.TDayConfig.offset;
        if (offset.count >= 0) {
          this.offset = 1;
          this.count = offset.count;
        } else {
          this.offset = -1;
          this.count = -offset.count;
        }
      }
      this.tDayRadioChange();
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeTDay: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  tDayRadioChange() {
    switch (this.TDayConfig.type) {
      case 'daily':
        this.dailyChange();
        break;
      case 'monthly':
        this.monthlyChange();
        break;
      case 'quarter':
        this.seasonChange();
        break;
      case 'annual':
        this.yearChange();
        break;
    }
  }

  dailyChange() {
    this.TDayConfig.description = '每个 ' + this.getSelectTitle(this.dateTypes, this.TDayConfig.offset.unit);
  }

  monthlyChange() {
    this.TDayConfig.description = '每月 ' + this.getSelectTitle(this.orderTypes, this.offset) + ' 第 '
      + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.TDayConfig.offset.unit);
  }

  seasonChange() {
    this.TDayConfig.description = '每季 ' + this.getSelectTitle(this.orderTypes, this.offset) + ' 第 '
      + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.TDayConfig.offset.unit);
  }

  yearChange() {
    this.TDayConfig.description = '每年 ' + this.getSelectTitle(this.orderTypes, this.offset) + ' 第 '
      + this.count + ' 个 ' + this.getSelectTitle(this.dateTypes, this.TDayConfig.offset.unit);
  }

  monthOffsetChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.monthlyChange();
  }

  monthCountChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.monthlyChange();
  }

  seasonOffsetChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.seasonChange();
  }

  seasonCountChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.seasonChange();
  }

  yearOffsetChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.yearChange();
  }

  yearCountChange() {
    this.TDayConfig.offset.count = this.offset * this.count;
    this.yearChange();
  }

  // 获取下拉选项的表述
  getSelectTitle(target: Array<any>, value): string {
    if (target && target.length > 0) {
      for (let item of target) {
        if (item.value === value) {
          return item.title;
        }
      }
    } else {
      return '';
    }
  }

  // 提交
  tDayOnSubmit() {
    this.nfDataChange.emit(this.TDayConfig);
    this.closeTDay.emit();
  }
}
